function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/ProfileApi";
import IntlMessage from '../commons/Intl';
import { Label, Profile, Avatar } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      AcessToken: "",
      Profile: null,
      UserName: "",
      UserMailAddress: "",
      ErrorMessages: []
    };

    _this.GetProfile();

    return _this;
  }
  /**
   * プロフィール取得
   */


  _createClass(MainComponent, [{
    key: "GetProfile",
    value: function GetProfile() {
      var _this2 = this;

      Api.GetProfile(function (data) {
        _this2.setState({
          AcessToken: data.AccessToken,
          Profile: data.Profile,
          UserName: data.Profile.UserName,
          UserMailAddress: data.Profile.UserMailAddress,
          ErrorMessages: []
        });

        if ($("#headerProfile")) {
          $("#headerProfile").text(data.Profile.UserName + "/" + $("#headerProfile").text().split("/")[1]);
        }

        _this2.GetThumbnailUrl();
      });
    }
    /**
     * サムネイル取得
     */

  }, {
    key: "GetThumbnailUrl",
    value: function GetThumbnailUrl() {
      if (!this.state.Profile || !this.state.Profile.UserId || !this.state.Profile.ThumbnailFileName) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        if ($("#headerThumbnail")) {
          $("#headerThumbnail").css("background-image", 'url("/assets/img/user_thumbnail_default.jpg")');
        }

        $("#thumbnailiconframe").css("background-image", 'url("/assets/img/user_thumbnail_default.jpg")');
        return;
      }

      Api.GetThumbnail(this.state.Profile.UserId.toString(), this.state.Profile.ThumbnailFileName, function (blob) {
        if ($("#headerThumbnail")) {
          $("#headerThumbnail").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
        }

        $("#thumbnailiconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("div", {
        id: "normal",
        className: "row"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modalIcon"
      }, /*#__PURE__*/React.createElement("div", {
        id: "thumbnailiconframe",
        className: "thumbnailicon40frame"
      })), /*#__PURE__*/React.createElement("h1", null, intl.format(Profile.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label",
        htmlFor: "UserName"
      }, intl.format(Label.UserName)), /*#__PURE__*/React.createElement("label", {
        className: "col-form-label text"
      }, this.state.Profile ? this.state.Profile.UserName : "")), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label",
        htmlFor: "UserMailAddress"
      }, intl.format(Label.MailAddress)), /*#__PURE__*/React.createElement("label", {
        className: "col-form-label text"
      }, this.state.Profile ? this.state.Profile.UserMailAddress : "")), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label",
        htmlFor: "Pin"
      }, intl.format(Label.Pin)), /*#__PURE__*/React.createElement("label", {
        className: "col-form-label text"
      }, this.state.Profile ? this.state.Profile.Pin : "")), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label",
        htmlFor: "ThumbnailFileName"
      }, intl.format(Label.Thumbnail)), /*#__PURE__*/React.createElement("label", {
        className: "col-form-label text"
      }, this.state.Profile ? this.state.Profile.ThumbnailFileName : "")), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-form-label",
        htmlFor: "AvatarFileName"
      }, intl.format(Label.Avatar)), /*#__PURE__*/React.createElement("label", {
        className: "col-form-label text"
      }, this.state.Profile == null ? intl.format(Avatar.Default) : this.state.Profile.AvatarFileName))))));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param queryRefreshInterval 検索リフレッシュインターバル
 */


export default function (el, common, queryRefreshInterval) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    queryRefreshInterval: queryRefreshInterval
  }), el);
}